import { useFocusEffect } from 'expo-router';
import { useCallback } from 'react';

import { trackView } from '../../logger/Logger';

export const useTrackViewOnFocus = (
    viewName: string,
    enabled: boolean = true,
) => {
    useFocusEffect(
        useCallback(() => {
            if (enabled) {
                trackView(viewName);
            }
        }, [enabled, viewName]),
    );
};
